import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  MiniCartComponent,
  MiniCartComponentService,
} from '@spartacus/cart/base/components/mini-cart';
import { ActiveCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { Observable, Subject, switchMap } from 'rxjs';
import { MiniCartPopUpComponent } from './mini-cart-pop-up/mini-cart-pop-up.component';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { takeUntil } from 'rxjs/operators';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { AuthService } from '@spartacus/core';

@Component({
  selector: 'app-kb-mini-cart',
  templateUrl: './kb-mini-cart.component.html',
  styleUrls: ['./kb-mini-cart.component.scss'],
  standalone: false
})
export class KbMiniCartComponent extends MiniCartComponent {
  miniCartCount$: Observable<OrderEntry[]>;
  onlineOrdering$: Observable<any>;
  state: boolean = true;
  private secureSubscription$ = new Subject<void>();

  isOrderBlocked$ = this.custIdService.isOrderBlocked$;
  constructor(
    protected override miniCartComponentService: MiniCartComponentService,
    public MatDialog: MatDialog,
    private activeCartService: ActiveCartFacade,
    public secureGuard: SecureGuard,
    public custIdService: CustomerIdService,
    private authService: AuthService
  ) {
    super(miniCartComponentService);
  }
  ngOnInit(): void {
    this.miniCartCount$ = this.authService.isUserLoggedIn().pipe(switchMap(isLoggedIn => isLoggedIn ? this.activeCartService.getEntries() : []));
    this.onlineOrdering$ = this.custIdService.onlineOrdering$;
  }

  openMiniCart(event: Event) {
    event.preventDefault();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.maxHeight = '500px';
    this.MatDialog.open(MiniCartPopUpComponent);
  }

  ngAfterViewInit() {
    this.secureGuard.successMsg$.pipe(takeUntil(this.secureSubscription$)).subscribe((currentState: boolean) => {
      this.state = currentState;
    })
  }

  ngOnDestroy() {
    this.secureSubscription$.next();
    this.secureSubscription$.complete();
  }
}
